import {useCallback, useContext, useEffect, useState} from "react";
import AppContext, {INTRO_MOVIE_FINISHED} from "../../../store";
import {webRTCObserver, EVENT_VIDEO_FINISHED} from "./useConfiguratorMount";

let init = false;
let isListenerApplied = false;

/*@TODO Need refactor
* WebRTC starts with enabled audio, according to the following settings:
* src/components/Configurator/hooks/useConfiguratorMount.js:24
* */
const getAudio = () => document.getElementsByTagName('audio')[0];
const getVideo = () => document.querySelector('.stream-size-container');

/*Audio functionality*/
function useSound() {
  const { streamStore } = useContext(AppContext);
  const [isSoundOn, setIsSoundOn] = useState(false);
  const play = useCallback(function() {
    setIsSoundOn(true);
    const audio = getAudio();
    audio.muted = false;
    audio.play();
    audio.volume = 1;
  }, [])

  const pause = useCallback(function() {
    setIsSoundOn(false);
    const audio = getAudio();
    audio.pause();
  }, [])

  const addVideoListener = useCallback(function() {
    if(!isListenerApplied) {
      isListenerApplied = true;
      const _sizeContainer = getVideo();
      _sizeContainer.addEventListener('click', play);
    }
  }, [])

  const removeVideoListener = useCallback(function() {
    if(isListenerApplied) {
      const _sizeContainer = getVideo();
      _sizeContainer.removeEventListener('click', play);
    }
  }, [])

  const toggleSound = useCallback((newVal = isSoundOn) => {
    if(newVal) {
      play()
    } else {
      pause();
    }
  }, [
    play,
    pause,
    isSoundOn,
  ]);

  useEffect(() => {
    if(!init) {
      init = true;
      if(!streamStore[INTRO_MOVIE_FINISHED]) {
        addVideoListener();
        webRTCObserver.subscribe(EVENT_VIDEO_FINISHED, removeVideoListener);
      }
    }

    if(streamStore[INTRO_MOVIE_FINISHED]) {
      pause()
    }

    return () => {
      removeVideoListener();
      webRTCObserver.unsubscribe(EVENT_VIDEO_FINISHED, removeVideoListener)
    }
  }, []);

  return {
    isSoundOn,
    toggleSound,
  }
}

export default useSound